const regexp = {
  "non-negative decimal number or empty string": /^(?:\d+(\.\d*)?|\.\d+|)$/,
  "non-negative integer or empty string": /^(?:\d+|)$/,
  "dosage value": /^[\d:./\-\s]*$/,
} as const;

type RegExpKeys = keyof typeof regexp;

/** Creates a simple, human readable abstraction over common Regular Expressions */
// eslint-disable-next-line import/prefer-default-export
export function testRegExp(key: RegExpKeys, value: string): boolean {
  return regexp[key].test(value);
}
